import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './language.service';
import { Observable, skip, switchMap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslationHelperService {

  lang$!: Observable<'en' | 'mr'>;  // ✅ declared but not initialized here

  constructor(
    public translate: TranslateService,
    private languageService: LanguageService,
  ) {
    this.lang$ = this.languageService.lang$;  // ✅ assigned after DI is ready
  }

  private toKey(value: string): string {
    return value.trim().replaceAll(' ', '_');
  }

  getFeature(feature: string): string {
    const key = `FEATURE.${this.toKey(feature)}`;
    const result = this.translate.instant(key);
    return result === key ? feature : result;
  }

  getFeatureGroup(featureGroup: string): string {
    const key = `FEATURE_GROUP.${this.toKey(featureGroup)}`;
    const result = this.translate.instant(key);
    return result === key ? featureGroup.replaceAll('_', ' ') : result;
  }

  getMenu(menuId: string): string {
    const key = `MENU.${this.toKey(menuId)}`;
    const result = this.translate.instant(key);
    return result === key ? menuId.replaceAll('_', ' ') : result;
  }

  whenLangReady(): Observable<unknown> {
    return this.languageService.lang$.pipe(
      skip(1),  // ✅ skip initial BehaviorSubject emission — only react to real changes
      switchMap(lang => this.translate.use(lang))
    );
  }

  get currentLang(): string {
    return this.languageService.currentLang;
  }

  switchLanguage(lang: 'en' | 'mr') {
    this.languageService.switchLanguage(lang);
  }

  toggle() {
    this.languageService.toggle();
  }
}